import React from 'react';

import PropTypes from 'prop-types';
import { HiChevronDown } from 'react-icons/hi';
import cn from 'classnames';

import { Text, IconButton, Menu } from 'modules/common';

import * as c from './constants';

function DropdownButton({
  type,
  withLeading,
  leadingItem,
  leadingType,
  label,
  menuProps,
  selectionProps,
  iconProps,
  options,
  containerClassName,
  onChange,
}) {
  const ref = React.useRef();
  const [isOpen, setIsOpen] = React.useState(false);

  const $type = c.dispatchType()?.[type];
  const $leadingType = c.dispatchLeadingType?.({
    selectionProps,
    iconProps,
    type,
  })?.[leadingType];

  const style = {
    background: $type?.background,
    text: $type?.text,
    border: $type?.border,
  };

  return (
    <button
      type="button"
      className={cn(
        'text-left flex items-center rounded relative bg-primary-500',
        style.background,
        style.text,
        style.border,
        containerClassName
      )}
      ref={ref}
      onClick={() => setIsOpen(!isOpen)}
    >
      <div className="flex items-center gap-ds-8 px-ds-12 flex-1">
        {withLeading && <>{leadingItem || $leadingType}</>}

        <Text weight="medium">{label}</Text>
      </div>

      <IconButton
        icon={<HiChevronDown className="h-ds-16 w-ds-16" />}
        className="border-0 border-l rounded-l-none"
        type={type}
      />

      <Menu
        isOpen={isOpen}
        clickOutsideProps={{
          ref,
          set: setIsOpen,
        }}
        className="right-0 top-11"
        options={options}
        {...menuProps}
        onChange={onChange}
      />
    </button>
  );
}

export default DropdownButton;

DropdownButton.defaultProps = {
  label: '',
  type: 'default',
  menuProps: {},
  selectionProps: {},
  iconProps: {},
  onChange: () => {},
  leadingItem: false,
  withLeading: true,
  leadingType: '',
  containerClassName: '',
  options: [],
};

DropdownButton.propTypes = {
  label: PropTypes.string,
  containerClassName: PropTypes.string,
  options: PropTypes.instanceOf(Array),
  withLeading: PropTypes.bool,
  menuProps: PropTypes.instanceOf(Object),
  selectionProps: PropTypes.instanceOf(Object),
  iconProps: PropTypes.instanceOf(Object),
  onChange: PropTypes.instanceOf(Function),
  leadingItem: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.element,
    PropTypes.string,
    PropTypes.instanceOf(Object),
    PropTypes.instanceOf(Function),
  ]),
  leadingType: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf(['checkbox', 'radio', 'info']),
  ]),
  type: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf(['default', 'secondary']),
  ]),
};
